import React from 'react';
import AllowanceInfo from './AllowanceInfo';
import AvatarDisplay from './AvatarDisplay';
import './ChildDashboardHeader.css';

function ChildDashboardHeader({ childName, avatarUrl }) {
  return (
    <div className="child-dashboard-header">
      <div className="child-dashboard-header__content">
        <div className="child-dashboard-header__avatar">
          <AvatarDisplay
            imageUrl={avatarUrl}
            childName={childName}
          />
        </div>
        <div className="child-dashboard-header__allowance">
          <AllowanceInfo />
        </div>
      </div>
    </div>
  );
}

export default ChildDashboardHeader;